import { MySubmission } from "@/api/generated/backendAPI.schemas";
import { bestOwnScore, unscoredMessage } from "@/utils/unscored";
import { getShortenedScore } from "@/utils/utils";

type Props = {
  myScored: boolean | undefined;
  myParticipantKind: string | null | undefined;
  mySubmissions: readonly MySubmission[] | undefined;
  ascending: boolean;
};

/**
 * 自分がスコアの対象外（運営・オブザーバー）のときの案内。
 * リーダーボードには載らないので、自分のベストスコアだけを見せる。対象なら何も出さない。
 */
function UnscoredNotice({ myScored, myParticipantKind, mySubmissions, ascending }: Props) {
  const notice = unscoredMessage(myScored, myParticipantKind);
  if (!notice) return null;
  const myBest = bestOwnScore(mySubmissions, ascending);
  return (
    <div
      role="status"
      className="mx-4 my-3 rounded-xl border border-[#dbe1e6] bg-[#f6f8fa] px-4 py-3 text-sm text-darkcolor"
    >
      <p className="font-bold">{notice}</p>
      <p className="mt-1">
        あなたのベストスコア：
        {myBest === null ? "まだありません" : getShortenedScore(myBest)}
      </p>
    </div>
  );
}

export default UnscoredNotice;
